export class TreeDataItem {

  id?: string | null;

  /**
   * Optional implementation of parent id, dependent on if api implements
   */
  parentId?: string | null;
  text?: string | null;
  toolTip?: string | null;
  hasChildren?: boolean | null;

  image?: string | null;
  spriteCssClass?: string | null;
  info?: string | null;

  dataType?: string | null;
  dataCode?: string | null;

  tagId?: string | null;

  isLocked?: boolean | null = null;

  items?: TreeDataItem[] | null;
}


export class TreeDataItemCheckHighlighted extends TreeDataItem {

  checked?: boolean | null = false;
  highlighted?: boolean | null = false;
  expanded?: boolean | null;
  
}

export class TreeInfoAuth {
  id?: string | null;

  excluded?: boolean | null = false;
  user?: boolean = false;

  hasChildExcludedIds?: boolean = false;
  hasChildCustomIds?: boolean = false;

  source?: string | null;
  sourceType?: string | null;


}
